export default "__VITE_ASSET__2dSI5ZWJ__"